import { connectColors } from '@/theme/colors';
import { Icon, Menu } from '@lego/connect-components-react';

type SelectableMenuItemProps = {
  value: string;
  label: string;
  isSelected: boolean;
  onClick: () => void;
};

export const SelectableMenuItem = ({
  value,
  label,
  isSelected,
  onClick,
}: SelectableMenuItemProps) => (
  <Menu.Item
    value={value}
    onClick={onClick}
    startEnhancer={
      isSelected ? (
        <Icon name="control-check" size="small" isChild />
      ) : (
        <span style={{ width: '16px' }} />
      )
    }
  >
    {isSelected ? (
      label
    ) : (
      <span style={{ color: connectColors.core.blue[1000] }}>{label}</span>
    )}
  </Menu.Item>
);
